<p-panel header="{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad' | hisUi}}">

    <div class="layoutBlock">
        <div class="columnFull">
            <button type="text" hisImage="plus_circ_green" class="transparent"
                (click)="createTravelAbroadAndOpenInputDialog()">
                <span>{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.button.addTravelAbroad'
                    | hisUi}}</span>
            </button>
            <button [disabled]='isDeleteAllButtonDisabled' type="text" hisImage="stop_cross" class="transparent"
                (click)="deleteAllTravelAbroad()">
                <span>{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.button.deleteAllTravelAbroad'
                    | hisUi}}</span>
            </button>
        </div>
        <div class="clearAndSpace"></div>

        <!-- Listview of TravelAbroad -->
        <ng-container *ngFor="let tempTravelAbroad of listTravelAbroad; let i = index">
            <div class="columnHalf">
                <div class="layoutBlock">
                    <div class="listviewBadgeLeft">
                        <div class="circleIconContainer">
                            <div class="circle-icon">
                                <div><img hisImage="milestone" class="inlineicon"
                                        title="{{'rm.erp.travelmanagement.businesstripapplication.icon.travelSection' | hisUi}}">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="listviewSideRight">
                        <h2>{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.listTravelAbroad'
                            |
                            hisUi}}
                            ({{i+1}})</h2>
                        <ul class="listSimple">
                            <li>
                                <div *ngIf="tempTravelAbroad.travelDay" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.travelDay'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{tempTravelAbroad.travelDay}}</div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="tempTravelAbroad.tripBeginDate" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.tripBeginDate'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{tempTravelAbroad.tripBeginDate | hisDate:
                                        dateTimeFormat}}</div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="tempTravelAbroad.tripEndDate" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.tripEndDate'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{tempTravelAbroad.tripEndDate | hisDate:
                                        dateTimeFormat}}</div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="tempTravelAbroad.travelItineraryFromSelected"
                                    class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.countryFrom'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{tempTravelAbroad.travelItineraryFromSelected.text}}
                                    </div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="tempTravelAbroad.destinationFrom" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.destinationFrom'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{tempTravelAbroad.destinationFrom}}</div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="tempTravelAbroad.travelItineraryToSelected" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.countryTo'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{tempTravelAbroad.travelItineraryToSelected.text}}
                                    </div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="tempTravelAbroad.destinationTo" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.destinationTo'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{tempTravelAbroad.destinationTo}}</div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="tempTravelAbroad.transportationSelected" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.meansOfTransport'
                                        | hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{tempTravelAbroad.transportationSelected.text}}
                                    </div>
                                </div>
                            </li>

                            <li>
                                <div *ngIf="tempTravelAbroad.note" class="labelTextWrapTwoColumn">
                                    <div class="labelWrapTwoColumn">
                                        {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.notes'
                                        |
                                        hisUi}}</div>
                                    <div class="textWrapTwoColumn">{{tempTravelAbroad.note}}</div>
                                </div>
                            </li>
                        </ul>

                        <button type="text" hisImage="pencil" class="transparent"
                            (click)="editTravelAbroadAndOpenInputDialog(i)">{{'common.edit' | hisUi}}</button>
                        <button type="text" hisImage="delete" class="transparent"
                            (click)="deleteTravelAbroad(i)">{{'common.delete' | hisUi}}</button>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</p-panel>

<!-- Inputdialog for creating or editing travelabroad -->
<ng-template #newOrEditTravelitineraryDialogContainer [ngIf]="isInputDialogVisible">
    <div>
        <p-dialog [(visible)]="isInputDialogVisible" height="auto" [draggable]="false" [responsive]="true"
            [modal]="true" [dismissableMask]="true" [blockScroll]="true">
            <p-header>
                <h2 *ngIf="travelAbroad.id === undefined else editTextAbroad">
                    {{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.addTravelAbroad'
                    |
                    hisUi}}</h2>
                <ng-template #editTextAbroad>
                    <h2>{{'rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.editTravelAbroad'
                        | hisUi}}
                    </h2>
                </ng-template>
            </p-header>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.travelDay"
                    [(ngModel)]="travelAbroad.travelDay" class="inputWidth100">
            </his-plam>

            <his-plam>
                <p-calendar #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.tripBeginDate"
                    [(ngModel)]="travelAbroad.tripBeginDate" [dateFormat]="dateTimeFormat" [showTime]="true"
                    styleClass="calendarWidth100" [monthNavigator]="true" [yearNavigator]="true"
                    [placeholder]="dateTimePlaceholderFormat">
                </p-calendar>
            </his-plam>

            <his-plam>
                <p-calendar #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.tripEndDate"
                    [(ngModel)]="travelAbroad.tripEndDate" [dateFormat]="dateTimeFormat" [showTime]="true"
                    styleClass="calendarWidth100" [monthNavigator]="true" [yearNavigator]="true"
                    [placeholder]="dateTimePlaceholderFormat">
                </p-calendar>
            </his-plam>

            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.countryFrom"
                    field="text" [(ngModel)]="travelAbroad.travelItineraryFromSelected"
                    hisEagerDataSource="{{'api/v1/rm/erp/travelmanagement/values/erpforeigncountry'}}?filter_validon={{currentDate}}"
                    [forceSelection]="true">
                </p-autoComplete>
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.destinationFrom"
                    [(ngModel)]="travelAbroad.destinationFrom" class="inputWidth100">
            </his-plam>

            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.countryTo"
                    field="text" [(ngModel)]="travelAbroad.travelItineraryToSelected"
                    hisEagerDataSource="{{'api/v1/rm/erp/travelmanagement/values/erpforeigncountry'}}?filter_validon={{currentDate}}"
                    [forceSelection]="true">
                </p-autoComplete>
            </his-plam>

            <his-plam>
                <input #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.destinationTo"
                    [(ngModel)]="travelAbroad.destinationTo" class="inputWidth100">
            </his-plam>

            <his-plam>
                <p-autoComplete #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.meansOfTransport"
                    field="text" [(ngModel)]="travelAbroad.transportationSelected"
                    hisEagerDataSource="{{'api/v1/rm/erp/travelmanagement/values/erptransportation'}}?filter_validon={{currentDate}}"
                    [forceSelection]="true">
                </p-autoComplete>
            </his-plam>

            <his-plam>
                <textarea #content
                    hisDdKey="rm.erp.travelmanagement.businesstripapplication.BusinesstripApplication.travelAbroad.notes"
                    class="textareaWidth100 expand" rows="1" [(ngModel)]="travelAbroad.note"></textarea>
            </his-plam>

            <button (click)="addTravelAbroadToListAndCloseInputDialog()"><span>{{ 'common.apply' | hisUi
                    }}</span></button>
            <button (click)="closeInputDialog()"><span>{{ 'common.cancel' | hisUi }}</span></button>

        </p-dialog>
    </div>
</ng-template>